import { TAB_NUMBER } from '../../constants';
import { TabButton } from '../../components/TabButton';
import Search from '../../../../components/Cycle/Search';
import { useMemo } from 'react';
import { useContractScreensTabsInteractor } from './interactor';
import { getBracketsText } from '../../utils/getBracketsText';
import { TabsRouter } from './router';
import Delimiter from '../../../../components/Delimiter/Delimiter';

export const CyclesTabs = () => {
  const { activeCycles, inactiveCycles, completedCycles, activeTab, onChangeTab, onChangeSearch } =
    useContractScreensTabsInteractor();

  const activeText = useMemo(() => {
    if (activeCycles === null) {
      return '';
    }

    return getBracketsText(activeCycles);
  }, [activeCycles]);

  const inactiveText = useMemo(() => {
    if (inactiveCycles === null) {
      return '';
    }

    return getBracketsText(inactiveCycles);
  }, [inactiveCycles]);

  const completedText = useMemo(() => {
    if (completedCycles === null) {
      return '';
    }

    return getBracketsText(completedCycles);
  }, [completedCycles]);

  const onClickInactiveHandler = () => {
    onChangeTab(TAB_NUMBER.INACTIVE);
  };

  const onClickActiveHandler = () => {
    onChangeTab(TAB_NUMBER.ACTIVE);
  };

  const onClickCompletedHandler = () => {
    onChangeTab(TAB_NUMBER.COMPLETED);
  };

  return (
    <div>
      <Delimiter className='c-contract-screens-view-modules-tabs mb-2 h-[1px] bg-foggy-mist' />
      <div className={'c-button-group grid auto-cols-fr xsm:grid-flow-col gap-x-3 gap-y-2 pb-4'}>
        <TabButton
          text={`Inactive ${inactiveText}`}
          onClick={onClickInactiveHandler}
          isActive={activeTab === TAB_NUMBER.INACTIVE}
        />
        <TabButton
          text={`Active ${activeText}`}
          onClick={onClickActiveHandler}
          isActive={activeTab === TAB_NUMBER.ACTIVE}
        />
        <TabButton
          text={`Completed ${completedText}`}
          onClick={onClickCompletedHandler}
          isActive={activeTab === TAB_NUMBER.COMPLETED}
        />
      </div>

      <Search onSearch={onChangeSearch} />

      {<TabsRouter active={activeTab} />}
    </div>
  );
};
